export type PathPowerUpPlacement = {
    position: number
    track: number
    up: 0 | 1 | 2
    type: 'battery' | 'plane' | 'shield' | 'heart' | 'coin'
}

export const powerUpPositions: PathPowerUpPlacement[] = [
     // Level 1 Tutorial
    { position: 49, track: 3, up: 0, type: 'coin' },
    { position: 50, track: 3, up: 0, type: 'coin' },
    { position: 51, track: 3, up: 0, type: 'coin' },

    { position: 79, track: 2, up: 0, type: 'coin' },
    { position: 80, track: 2, up: 0, type: 'coin' },
    { position: 81, track: 2, up: 0, type: 'coin' },

    { position: 108, track: 2, up: 1, type: 'coin' },
    { position: 110, track: 2, up: 2, type: 'coin' },
    { position: 112, track: 2, up: 1, type: 'coin' },

    { position: 140, track: 1, up: 0, type: 'heart' },
    { position: 140, track: 2, up: 0, type: 'heart' },
    { position: 140, track: 3, up: 0, type: 'heart' },

    { position: 270, track: 1, up: 0, type: 'shield' },
    { position: 270, track: 2, up: 0, type: 'shield' },
    { position: 270, track: 3, up: 0, type: 'shield' },

    // Level 1  
    { position: 164, track: 3, up: 0, type: 'coin' },
    { position: 165, track: 3, up: 0, type: 'coin' },
    { position: 166, track: 3, up: 0, type: 'coin' },

    { position: 195, track: 2, up: 0, type: 'coin' },
    { position: 196, track: 2, up: 0, type: 'coin' },
    { position: 197, track: 2, up: 0, type: 'coin' },

    { position: 220, track: 1, up: 0, type: 'coin' },
    { position: 221, track: 1, up: 0, type: 'coin' },
    { position: 222, track: 1, up: 0, type: 'coin' },

    { position: 246, track: 3, up: 0, type: 'coin' },
    { position: 247, track: 3, up: 1, type: 'coin' },
    { position: 248, track: 3, up: 2, type: 'coin' },
    { position: 249, track: 3, up: 1, type: 'coin' },
    { position: 250, track: 3, up: 0, type: 'coin' },

    { position: 300, track: 3, up: 0, type: 'coin' },
    { position: 301, track: 3, up: 0, type: 'coin' },
    { position: 302, track: 3, up: 0, type: 'coin' },

    { position: 317, track: 2, up: 2, type: 'heart' },

    { position: 340, track: 3, up: 0, type: 'coin' },
    { position: 341, track: 3, up: 1, type: 'coin' },
    { position: 342, track: 3, up: 2, type: 'coin' },
    { position: 343, track: 3, up: 1, type: 'coin' },
    { position: 344, track: 3, up: 0, type: 'coin' },

    // Level 2 Tutorial
    { position: 440, track: 1, up: 0, type: 'battery' },
    { position: 440, track: 2, up: 0, type: 'battery' },
    { position: 440, track: 3, up: 0, type: 'battery' },

    // Level 2
    { position: 498, track: 1, up: 0, type: 'coin' },
    { position: 499, track: 1, up: 1, type: 'coin' },
    { position: 500, track: 1, up: 2, type: 'coin' },
    { position: 501, track: 1, up: 1, type: 'coin' },
    { position: 502, track: 1, up: 0, type: 'coin' },

    { position: 541, track: 2, up: 1, type: 'coin' },
    { position: 542, track: 2, up: 2, type: 'coin' },
    { position: 543, track: 2, up: 1, type: 'coin' },

    { position: 593, track: 3, up: 0, type: 'battery'},

    { position: 628, track: 3, up: 0, type: 'coin' },
    { position: 629, track: 3, up: 0, type: 'coin' },
    { position: 630, track: 3, up: 0, type: 'coin' },

    { position: 668, track: 1, up: 0, type: 'shield' },

    { position: 685, track: 3, up: 0, type: 'coin' },
    { position: 705, track: 2, up: 0, type: 'coin' },
    { position: 722, track: 1, up: 0, type: 'coin' },
    { position: 723, track: 1, up: 0, type: 'coin' },
    { position: 724, track: 1, up: 0, type: 'coin' },
    { position: 740, track: 3, up: 0, type: 'coin' },

    { position: 804, track: 3, up: 0, type: 'coin' },
    { position: 805, track: 3, up: 0, type: 'coin' },
    { position: 806, track: 3, up: 0, type: 'coin' },

    { position: 850, track: 1, up: 0, type: 'coin' },

    { position: 892, track: 3, up: 0, type: 'battery' },

    // Level 3 Tutorial
    { position: 1030, track: 1, up: 0, type: 'plane' },
    { position: 1030, track: 2, up: 0, type: 'plane' },
    { position: 1030, track: 3, up: 0, type: 'plane' },

    { position: 1085, track: 1, up: 0, type: 'coin' },
    { position: 1086, track: 1, up: 0, type: 'coin' },
    { position: 1087, track: 1, up: 0, type: 'coin' },

    // Level 3
    { position: 1120, track: 3, up: 2, type: 'coin' },

    { position: 1175, track: 3, up: 0, type: 'coin' },
    { position: 1176, track: 3, up: 0, type: 'coin' },
    { position: 1177, track: 3, up: 0, type: 'coin' },

    
    { position: 1194, track: 1, up: 0, type: 'coin' },
    { position: 1195, track: 1, up: 0, type: 'coin' },
    { position: 1196, track: 1, up: 0, type: 'coin' },

    { position: 1252, track: 3, up: 0, type: 'shield' },

    { position: 1278, track: 1, up: 1, type: 'coin' },
    { position: 1280, track: 1, up: 2, type: 'coin' },
    { position: 1282, track: 1, up: 1, type: 'coin' },

    { position: 1348, track: 1, up: 0, type: 'coin' },
    { position: 1349, track: 1, up: 0, type: 'coin' },
    { position: 1350, track: 1, up: 0, type: 'coin' },

    { position: 1372, track: 1, up: 0, type: 'heart' },

    { position: 1390, track: 3, up: 2, type: 'coin' },

    { position: 1416, track: 3, up: 0, type: 'coin' },
    { position: 1417, track: 3, up: 0, type: 'coin' },
    { position: 1418, track: 3, up: 0, type: 'coin' },

    { position: 1520, track: 2, up: 2, type: 'coin' },

    { position: 1494, track: 1, up: 0, type: 'shield' },
    { position: 1494, track: 3, up: 0, type: 'battery' },

    { position: 1560, track: 3, up: 0, type: 'coin' },
    { position: 1561, track: 3, up: 0, type: 'coin' },
    { position: 1562, track: 3, up: 0, type: 'coin' },

    { position: 1620, track: 3, up: 0, type: 'plane' },

    { position: 1629, track: 1, up: 0, type: 'coin' },
    { position: 1630, track: 1, up: 0, type: 'coin' },
    { position: 1631, track: 1, up: 0, type: 'coin' },
    
    { position: 1650, track: 2, up: 2, type: 'coin' },
    { position: 1664, track: 1, up: 0, type: 'coin' },

    { position: 1690, track: 2, up: 2, type: 'coin' },

    { position: 1758, track: 1, up: 0, type: 'coin' },
    { position: 1760, track: 1, up: 1, type: 'coin' },
    { position: 1762, track: 1, up: 2, type: 'coin' },
    { position: 1764, track: 1, up: 1, type: 'coin' },
    { position: 1766, track: 1, up: 0, type: 'coin' },

    // Level 4
    { position: 1930, track: 2, up: 0, type: 'coin' },
    { position: 1931, track: 2, up: 0, type: 'coin' },
    { position: 1932, track: 2, up: 0, type: 'coin' },


    { position: 1988, track: 1, up: 0, type: 'shield' },

    { position: 1998, track: 3, up: 0, type: 'coin' },
    { position: 1999, track: 3, up: 0, type: 'coin' },
    { position: 2000, track: 3, up: 0, type: 'coin' },

    { position: 2100, track: 2, up: 0, type: 'coin' },
    { position: 2101, track: 2, up: 0, type: 'coin' },
    { position: 2102, track: 2, up: 0, type: 'coin' },

    { position: 2077, track: 2, up: 0, type: 'coin' },
    { position: 2140, track: 3, up: 2, type: 'coin' },
    { position: 2154, track: 2, up: 2, type: 'coin' },

    { position: 2189, track: 3, up: 0, type: 'heart' },
    { position: 2195, track: 1, up: 0, type: 'battery' },

    { position: 2380, track: 2, up: 2, type: 'coin' },

    { position: 2425, track: 3, up: 0, type: 'plane' },

    { position: 2265, track: 2, up: 0, type: 'coin' },
    { position: 2267, track: 2, up: 2, type: 'coin' },
    { position: 2269, track: 2, up: 0, type: 'coin' },

    { position: 2322, track: 3, up: 0, type: 'coin' },
    { position: 2323, track: 3, up: 0, type: 'coin' },
    { position: 2324, track: 3, up: 0, type: 'coin' },

    { position: 2570, track: 3, up: 0, type: 'coin' },
    { position: 2571, track: 3, up: 0, type: 'coin' },
    { position: 2572, track: 3, up: 0, type: 'coin' },

    { position: 2590, track: 1, up: 2, type: 'coin' },

    { position: 2618, track: 3, up: 0, type: 'coin' },
    { position: 2642, track: 2, up: 2, type: 'coin' },

    { position: 2681, track: 2, up: 0, type: 'coin' },
    { position: 2683, track: 2, up: 1, type: 'coin' },
    { position: 2685, track: 2, up: 2, type: 'coin' },
    { position: 2687, track: 2, up: 1, type: 'coin' },
    { position: 2689, track: 2, up: 0, type: 'coin' },
]
